import { render, staticRenderFns } from "./preDeliveryNoteGoods.vue?vue&type=template&id=8f7bc688&scoped=true&"
import script from "./preDeliveryNoteGoods.vue?vue&type=script&lang=js&"
export * from "./preDeliveryNoteGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7bc688",
  null
  
)

export default component.exports